import type { ReactNode } from 'react';

import type { IButtonProps } from '../Button/_props';

/**
 * Snackbar Button
 */

export type SnackButtonProps = Omit<IButtonProps, 'variant' | 'size' | 'type'> & { label: string };

/**
 * Snackbar Variants
 */

export enum SnackbarVariantsEnum {
  Primary = 'Primary',
  Secondary = 'Secondary',
}

export type SnackbarVariantsType = keyof typeof SnackbarVariantsEnum;

/**
 * Snackbar Sizes
 */

export enum SnackbarSizesEnum {
  Full = 'Full',
  Default = 'Default',
  Small = 'Small',
}

export type SnackbarSizesType = keyof typeof SnackbarSizesEnum;

/**
 * Snackbar States
 */

export enum SnackbarStatesEnum {
  Loading = 'Loading',
  Visible = 'Visible',
  Closed = 'Closed',
}

export type SnackbarStatesType = keyof typeof SnackbarStatesEnum;

/**
 * Snackbar
 */

export type SnackbarProps = {
  children: ReactNode;
  state?: SnackbarStatesType;
  variant?: SnackbarVariantsType;
  size?: SnackbarSizesType;
  float?: boolean;
  primaryButtonProps?: SnackButtonProps;
  secondaryButtonProps?: SnackButtonProps;
  customButton?: JSX.Element;
  className?: string;
  fadeOutTiming?: 4 | 5 | 6 | 7 | 8 | 9 | 10;
};
